// extracted by mini-css-extract-plugin
module.exports = {"MainContainer":"EventInstructions_MainContainer__a0H96"};